<template>
  <div></div>
</template>

<script>
  import apiAuth from '@/js/api/auth';

  export default {
    mounted() {
      apiAuth.logout();
      this.$root.$data.user = undefined;
      this.$router.push('login');
    },
  };
</script>



// WEBPACK FOOTER //
// Logout.vue?20264ebf